import httpService from "@/utils/httpService";

const baseUrl = "api/Clients";

export default {
    get(params, companyId) {
        // Use companyId in URL if provided, otherwise use regular endpoint
        const url = companyId ? `api/${companyId}/Clients` : baseUrl;
        return httpService.get({
            url,
            params,
        });
    },
    getCounts(params, companyId) {
        // Use companyId in URL if provided, otherwise use regular endpoint
        const url = companyId ? `api/${companyId}/Clients/counts` : `${baseUrl}/counts`;
        return httpService.get({
            url,
            params,
        });
    },
    getById(id, companyId) {
        // Use companyId in URL if provided, otherwise use regular endpoint
        const url = companyId ? `api/${companyId}/Clients/${id}` : `${baseUrl}/${id}`;
        return httpService.get({
            url,
        });
    },
    add(data, companyId) {
        // Use companyId in URL if provided, otherwise use regular endpoint
        const url = companyId ? `api/${companyId}/Clients` : baseUrl;
        
        // Remove companyId from data if it's already in the URL to avoid duplication
        if (companyId) {
            /* eslint-disable-next-line */
            const { companyId: _, ...dataWithoutCompanyId } = data.companyId ? data : { ...data, companyId };
            data = dataWithoutCompanyId;
        }
        
        return httpService.post({
            url,
            data,
        });
    },
    update(data, companyId) {
        // Use companyId in URL if provided, otherwise use regular endpoint
        const url = companyId ? `api/${companyId}/Clients/${data.id}` : `${baseUrl}/${data.id}`;
        
        // Remove companyId from data if it's already in the URL to avoid duplication
        if (companyId) {
            /* eslint-disable-next-line */
            const { companyId: _, ...dataWithoutCompanyId } = data.companyId ? data : { ...data, companyId };
            data = dataWithoutCompanyId;
        }
        
        return httpService.put({
            url,
            data,
        });
    },
    delete(id, companyId) {
        // Use companyId in URL if provided, otherwise use regular endpoint
        const url = companyId ? `api/${companyId}/Clients/${id}` : `${baseUrl}/${id}`;
        
        return httpService.delete({
            url,
        });
    },
} 